
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5307',
  depVersions: {
  "data-privacy-request-ui": "static-1.5307",
  "data-fetching-client": "static-1.9460",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7787",
  "hub-http-shared-msw-handlers": "static-1.9435",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11205",
  "I18n": "static-7.1564",
  "jasmine-runner": "static-1.6253",
  "privacy-center-public-service-types": "static-1.4570",
  "quartz": "static-1.6702",
  "react-dlb": "static-1.71",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5343",
  "UIComponents": "static-3.8152",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.81",
  "foundations-assets": "static-1.4616",
  "foundations-components": "static-1.7488",
  "foundations-components-test-utils": "static-1.4971",
  "foundations-theming": "static-1.4191",
  "hub-http": "static-1.5966",
  "quartz-config": "static-1.480",
  "quartz-core": "static-1.5921",
  "quick-fetch": "static-1.3718",
  "raven": "static-3.5624",
  "react": "static-7.177",
  "react-rhumb": "static-1.16424",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10915",
  "usage-tracker": "static-1.7114",
  "usage-tracker-anonymous": "static-1.5531",
  "usage-tracker-core": "static-1.6964",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3917",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3210",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2979",
  "quartz-webpack": "static-1.2926",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "HeadJS": "static-2.706",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2898",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3887",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "react-utils": "static-2.5157",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4110",
  "rpc-client-utils": "static-1.4415",
  "HubStyle": "static-2.11513",
  "ui-addon-draggable": "static-3.4548",
  "cssUtils": "static-1.726",
  "hs-story-utils": "static-1.9209",
  "icons": "static-2.619",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1086",
  "bend-plugin-foundations-components": "static-1.3757",
  "floating-ui": "static-1.51",
  "foundations-theming-specialty": "static-1.1907",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1138",
  "ui-fonts": "static-1.467",
  "foundations-components-legacy": "static-1.513",
  "bend-plugin-foundations-theming": "static-1.2674",
  "foundations-theming-base": "static-1.3176",
  "stylex": "static-1.27",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.789",
  "hubspotter-http": "static-1.4461",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.377",
  "quartz-head": "static-1.367",
  "quartz-i18n": "static-1.377",
  "quartz-routing": "static-1.132",
  "quartz-test": "static-1.377",
  "usage-tracker-container": "static-1.7104",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2926",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.65",
  "sassPrefix": "static-1.151",
  "hubspotter-http-shared-msw-handlers": "static-1.9433"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5307",
  "data-fetching-client": "/data-fetching-client/static-1.9460",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7787",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9435",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11205",
  "I18n": "/I18n/static-7.1564",
  "jasmine-runner": "/jasmine-runner/static-1.6253",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4570",
  "quartz": "/quartz/static-1.6702",
  "react-dlb": "/react-dlb/static-1.71",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5343",
  "UIComponents": "/UIComponents/static-3.8152",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "foundations-assets": "/foundations-assets/static-1.4616",
  "foundations-components": "/foundations-components/static-1.7488",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4971",
  "foundations-theming": "/foundations-theming/static-1.4191",
  "hub-http": "/hub-http/static-1.5966",
  "quartz-config": "/quartz-config/static-1.480",
  "quartz-core": "/quartz-core/static-1.5921",
  "quick-fetch": "/quick-fetch/static-1.3718",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.177",
  "react-rhumb": "/react-rhumb/static-1.16424",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10915",
  "usage-tracker": "/usage-tracker/static-1.7114",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5531",
  "usage-tracker-core": "/usage-tracker-core/static-1.6964",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3210",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2979",
  "quartz-webpack": "/quartz-webpack/static-1.2926",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "HeadJS": "/HeadJS/static-2.706",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2898",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3887",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "react-utils": "/react-utils/static-2.5157",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4110",
  "rpc-client-utils": "/rpc-client-utils/static-1.4415",
  "HubStyle": "/HubStyle/static-2.11513",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4548",
  "cssUtils": "/cssUtils/static-1.726",
  "hs-story-utils": "/hs-story-utils/static-1.9209",
  "icons": "/icons/static-2.619",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1086",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3757",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1907",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1138",
  "ui-fonts": "/ui-fonts/static-1.467",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.513",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2674",
  "foundations-theming-base": "/foundations-theming-base/static-1.3176",
  "stylex": "/stylex/static-1.27",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "hubspotter-http": "/hubspotter-http/static-1.4461",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.377",
  "quartz-head": "/quartz-head/static-1.367",
  "quartz-i18n": "/quartz-i18n/static-1.377",
  "quartz-routing": "/quartz-routing/static-1.132",
  "quartz-test": "/quartz-test/static-1.377",
  "usage-tracker-container": "/usage-tracker-container/static-1.7104",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.65",
  "sassPrefix": "/sassPrefix/static-1.151",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9433"
}
};
